import Icon from '../components/Icon.vue'

Icon.register({
  'truck-moving': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M621.3 237.3L562.8 178.8C550.8 166.8 534.5 160.1 517.5 160.1H480V64C480 46.3 465.7 32 448 32H32C14.3 32 0 46.3 0 64V400C0 444.2 35.8 480 80 480 106.3 480 129.4 467.1 144 447.6 158.6 467.2 181.7 480 208 480 252.2 480 288 444.2 288 400 288 394.5 287.4 389.2 286.4 384H449.6C448.5 389.2 448 394.5 448 400 448 444.2 483.8 480 528 480S608 444.2 608 400C608 394.5 607.4 389.2 606.4 384H624C632.8 384 640 376.8 640 368V282.5C640 265.5 633.3 249.3 621.3 237.3zM80 432C62.4 432 48 417.6 48 400S62.4 368 80 368 112 382.4 112 400 97.6 432 80 432zM208 432C190.4 432 176 417.6 176 400S190.4 368 208 368 240 382.4 240 400 225.6 432 208 432zM480 208H517.5C521.8 208 525.8 209.7 528.8 212.7L572.1 256H480V208zM528 432C510.4 432 496 417.6 496 400S510.4 368 528 368 560 382.4 560 400 545.6 432 528 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/truck-moving.js
// module id = SIe3
// module chunks = 144